import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../imageWithBasePath";
import { getLang, setLang } from "../../../../lang";

const LanguageDropdown = ({ isMobile = false }) => {
  const currentLang = getLang();

  const languages = [
    { code: "en", label: "English", flag: "assets/img/flags/us-flag.svg" },
    { code: "ja", label: "日本語", flag: "assets/img/flags/japan.svg" },
    { code: "zh", label: "中文", flag: "assets/img/flags/cn.png" },
    { code: "hi", label: "हिंदी", flag: "assets/img/flags/in.png" },
    { code: "es", label: "Español", flag: "assets/img/flags/es.png" },
    { code: "ru", label: "Русский", flag: "assets/img/flags/ru.png" },
    { code: "ar", label: "العربية", flag: "assets/img/flags/arab-flag.svg" },
    { code: "fr", label: "Français", flag: "assets/img/flags/france-flag.svg" },
    { code: "it", label: "Italiano", flag: "assets/img/flags/it.png" },
    { code: "de", label: "Deutsch", flag: "assets/img/flags/de.png" },
    { code: "pt-br", label: "Português (Brasil)", flag: "assets/img/flags/brazil.svg" },
    { code: "pt", label: "Português (Portugal)", flag: "assets/img/flags/pt.png" },
  ];


  const current =
    languages.find((l) => l.code === currentLang) || languages[0];

  return (
    <div className={`dropdown flag-dropdown mb-2 ${isMobile ? "" : "me-3"}`}>
      <Link
        to="#"
        className={`dropdown-toggle d-inline-flex align-items-center ${isMobile ? "bg-white border w-100 justify-content-center" : ""
          }`}
        data-bs-toggle="dropdown"
      >
        <ImageWithBasePath src={current.flag} className="me-2" alt="flag" />
        {current.label}
      </Link>

      <ul className="dropdown-menu p-2 mt-2">
        {languages.map((lang) => (
          <li key={lang.code}>
            <button
              className="dropdown-item rounded d-flex align-items-center w-100 border-0 bg-transparent"
              onClick={() => setLang(lang.code as any)}
            >
              <ImageWithBasePath
                src={lang.flag}
                className="me-2"
                alt={lang.label}
              />
              {lang.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageDropdown;
